import { FaStar } from "react-icons/fa";

const StarRating = ({ rating, setRating, onSubmit }) => {
  return (
    <div className="d-flex justify-content-center my-3">
      <div
        className="p-3 rounded-4 shadow-sm text-center"
        style={{
          background: "#fff",
          maxWidth: "260px",
          width: "100%",
          border: "1px solid #eee",
        }}
      >
        <small className="text-muted fw-semibold d-block mb-2">
          ⭐ Rate this video
        </small>

        {/* BIG STARS */}
        <div className="d-flex justify-content-center gap-2 mb-2">
          {[1, 2, 3, 4, 5].map((star) => (
            <FaStar
              key={star}
              size={34}   // ⭐ Bigger stars
              onClick={() => setRating(star)}
              style={{
                cursor: "pointer",
                transition: "0.3s",
                color: star <= rating ? "#ffc107" : "#e4e5e9",
                transform: star === rating ? "scale(1.15)" : "scale(1)",
              }}
            />
          ))}
        </div>

        {rating > 0 && (
          <small className="text-muted d-block mb-2">
            You selected <strong>{rating}/5</strong>
          </small>
        )}

        <button
          className="btn btn-primary btn-sm px-4"
          disabled={!rating}
          onClick={() => onSubmit(rating)}
        >
          Submit Rating
        </button>
      </div>
    </div>
  );
};

export default StarRating;
